import React from 'react';

const defaultUser = {
  isLoggedIn: false,
  isGlobalAdmin: false,
  isBreweryAdmin: false,
  isLoading: true,
  /** Firebase Auth uid; `null` when logged out */
  uid: null,
  /** Firebase `emailVerified`; `null` when logged out */
  emailVerified: null,
  userName: null,
  /**
   * Resolved address for UI: `user.email` or OAuth provider `email` when top-level is null
   * (e.g. “multiple accounts per email” / provider-only primary).
   */
  userEmail: null,
};

/** Fallback when no provider (tests). */
function defaultRefreshAuthSession() {
  return Promise.resolve({
    isLoggedIn: false,
    isGlobalAdmin: false,
    isBreweryAdmin: false,
    isLoading: false,
    uid: null,
    emailVerified: null,
    userName: null,
    userEmail: null,
  });
}

const UserContext = React.createContext(defaultUser);
const UserProvider = UserContext.Provider;
const UserConsumer = UserContext.Consumer;

/** `() => Promise<userState>` — reapplies `publishUserSession` for `auth.currentUser` (e.g. after `reload()`). */
const AuthSessionSyncContext =
  React.createContext(defaultRefreshAuthSession);

export {
  AuthSessionSyncContext,
  defaultRefreshAuthSession,
  defaultUser,
  UserContext,
  UserProvider,
  UserConsumer,
};
